<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="color"
          :dark="dark"
          x-large
          :text="text"
          v-bind="attrs"
          v-on="on"
        >
          {{ buttonText }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Apply</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              @submit.prevent="handleVideoSubmit"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    accept="video/*"
                    placeholder="Upload Video"
                    prepend-icon="mdi-camera"
                    label="Your Video"
                    name="videoFile"
                    v-model="videoFile"
                    ref="videoFile"
                    id="videoFile"
                    @change="handleVideoChange"
                    required
                    :rules="rules"
                    :show-size="1000"
                    >Upload my awesome video</v-file-input
                  >
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    accept=".doc,.docx,.pdf"
                    placeholder="Upload Resume"
                    prepend-icon="mdi-file"
                    label="Your Resume"
                    :show-size="1000"
                    ref="file"
                    id="file"
                    v-model="file"
                    required
                    :rules="rules"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <!-- <v-btn color="blue darken-1" text @click="this.test"> Test </v-btn> -->
          <v-btn
            type="submit"
            :disabled="!valid"
            color="#FC4A46"
            class="apply"
            @click="handleApply"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="successDialog"
      persistent
      max-width="600px"
      height="400px"
    >
      <v-card>
        <v-card-title v-if="handleAppliedSuccess">
          You have successfully applied!
        </v-card-title>
        <v-card-title v-else
          >Applying for Sales Representative...
        </v-card-title>
        <v-card-actions class="justify-center d-flex">
          <v-btn
            @click="stop"
            color="#FC4A46"
            dark
            x-large
            :disabled="!appliedSuccess"
            >Finish</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="inProgressDialog"
      persistent
      max-width="600px"
      height="400px"
    >
      <v-card>
        <v-card-title>
          <div class="d-flex justify-center text-hrng text-center">
            We are currently receiving a lot of traffic from HRNG users! Please
            do not click out, or navigate away from the page. Your video and
            resume are being uploaded for review. We appreciate your patience.
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import VueConfetti from 'vue-confetti';
import Vue from 'vue';
import { authComputed } from '@/store/helpers';

Vue.use(VueConfetti);

export default {
  computed: {
    ...authComputed,
  },
  data: () => ({
    dialog: false,
    file: '',
    videoFile: '',
    vimeoId: null,
    vimeoThumb: '',
    valid: false,
    rules: [(value) => !!value || 'Required.'],
    successDialog: false,
    inProgressDialog: false,
    appliedSuccess: false,
    resumeId: null,
  }),
  props: [
    'buttonText',
    'color',
    'dark',
    'text',
    'candidateId',
    'candidateFirstName',
    'candidateSurname',
    'jobPostId',
  ],

  methods: {
    handleApply() {
      this.go();
    },

    async go() {
      try {
        await Promise.all([
          this.postResume(),
          this.getLastResume(),
          this.postVideo(),
          //this.putCandidateData(),
        ]);
      } catch (e) {
        console.log(e);
      }
    },

    // create applicant
    async createApplicant() {
      axios.post(
        process.env.VUE_APP_REST_HTTP
          ? `${process.env.VUE_APP_REST_HTTP}/upload`
          : 'http://localhost:1337/applicants',
        {}
      );
    },

    async postResume() {
      console.log('post resume');
      this.inProgressDialog = true;
      let formData = new FormData();
      formData.append('files', this.file);
      console.log('>> formData >> ', formData);

      axios.post(
        process.env.VUE_APP_REST_HTTP
          ? `${process.env.VUE_APP_REST_HTTP}/upload`
          : 'http://localhost:1337/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    },

    async getLastResume() {
      const self = this;
      console.log('getLastResume');
      axios
        .get(
          process.env.VUE_APP_REST_HTTP
            ? `${process.env.VUE_APP_REST_HTTP}/upload/files?_sort=created_at:DESC`
            : 'http://localhost:1337/upload/files?_sort=created_at:DESC'
        )
        .then(function (response) {
          self.resumeId = response.data[0].id;
        });
    },

    //   client.request(
    //     {
    //       method: 'GET',
    //       path: `videos/${self.getUserData.candidate.video}`,
    //     },
    //     function (error, body) {
    //       if (error) {
    //         console.log(error);
    //       }

    //       console.log(body);
    //       axios.put(
    //         process.env.VUE_APP_REST_HTTP
    //           ? `${process.env.VUE_APP_REST_HTTP}/candidates/${self.getUserData.candidate.id}`
    //           : `http://localhost:1337/candidates/${self.getUserData.candidate.id}`,
    //         {
    //           videoThumb: body.pictures.sizes[1].link,
    //         }
    //       );
    //     }
    //   );

    async postVideo() {
      const self = this;
      this.$confetti.start();
      window.setTimeout(() => {
        this.$confetti.stop();
      }, 3000);
      let Vimeo = require('vimeo').Vimeo;
      let client = new Vimeo(
        '757d27075fbb47670d8e45a767f6c2ce7b050279',
        'FAmshigr/NFiWUjSw1Hi/etD4b7Lflh318tHkR7RiTGT3rVhna7V5vkU60I/nXO+CK5fhDzdYTb/7BTyKh7VERJ6NmQX7VHfMsl1Y3DzgT2oFa5eAiEEjPHXq2L/goS4',
        '9ea71d9d177393d7954e1a5a725b070c'
      );

      client.upload(
        this.videoFile,
        {
          name: this.candidateFirstName + this.candidateSurname,
          description: 'Candidate Job Application Video',
          privacy: { view: 'unlisted' },
        },
        function (uri) {
          console.log('Your video URI is: ' + uri);
          self.vimeoId = uri.replace(/\D/g, '');
          self.putCandidateData();
          //self.getVimeoThumb(client, uri.replace(/\D/g, ''));
        },
        function (bytes_uploaded, bytes_total) {
          var percentage = ((bytes_uploaded / bytes_total) * 100).toFixed(2);
          console.log(bytes_uploaded, bytes_total, percentage + '%');
        },
        function (error) {
          console.log('Failed because: ' + error);
        }
      );
    },

    putCandidateData() {
      var self = this;
      console.log('POSTING');
      axios
        .post(
          process.env.VUE_APP_REST_HTTP
            ? `${process.env.VUE_APP_REST_HTTP}/applicants`
            : `http://localhost:1337/applicants`,
          {
            video: self.vimeoId,
            resume: self.resumeId,
            job_post: self.jobPostId,
            // candidate: self.candidateId,
            user: self.getUserData.id,
            dateApplied: Date.now(),
            //videoThumb: self.vimeoThumb,
            //videoThumb: self.getVimeoThumb(),
          }
        )
        .then(function () {
          console.log('done');
          self.handleAppliedSuccess();
          //self.$store.dispatch('UPDATE_VIDEO', self.vimeoId);
        });
    },

    getVimeoThumb(client, uri) {
      const self = this;
      console.log(uri);
      console.log(`${uri.replace(/\D/g, '')}`);
      client.request(
        {
          method: 'GET',
          path: `me/videos/${uri.replace(/\D/g, '')}`,
          //path: 'https://api.vimeo.com/videos/467927750',
          //path: uri,
          //path: `https://api.vimeo.com/videos/${uri.replace(/\D/g, '')}`,
          //path: `me/videos/${uri.replace(/\D/g, '')}`,
        },
        function (error, body) {
          if (error) {
            console.log(error);
          }

          console.log(body);
          self.vimeoThumb = body.pictures.sizes[1].link;
          self.putCandidateData();
        }
      );
    },

    start() {
      this.inProgressDialog = false;
      this.successDialog = true;
    },
    stop() {
      this.$confetti.stop();
      this.successDialog = false;
      this.$router.go(this.$router.currentRoute);
    },

    handleVideoChange() {
      console.log(this.videoFile);
    },
    handleClose() {
      this.dialog = false;
    },
    handleAppliedSuccess() {
      this.appliedSuccess = true;
      this.start();
    },

    vimeoUpload() {
      try {
        let Vimeo = require('vimeo').Vimeo;
        let client = new Vimeo(
          '757d27075fbb47670d8e45a767f6c2ce7b050279',
          'FAmshigr/NFiWUjSw1Hi/etD4b7Lflh318tHkR7RiTGT3rVhna7V5vkU60I/nXO+CK5fhDzdYTb/7BTyKh7VERJ6NmQX7VHfMsl1Y3DzgT2oFa5eAiEEjPHXq2L/goS4',
          '9ea71d9d177393d7954e1a5a725b070c'
          // `${process.env.VUE_APP_VIMEO_CLIENT_ID}`,
          // `${process.env.VUE_APP_VIMEO_CLIENT_SECRET}`,
          // `${process.env.VUE_APP_VIMEO_CLIENT_ACCESS_TOKEN}`
        );

        client.upload(
          this.videoFile,
          {
            name: this.candidateFirstName + this.candidateSurname,
            description: 'Candidate Job Application Video',
            privacy: { view: 'unlisted' },
          },
          function (uri) {
            console.log('Your video URI is: ' + uri);

            //return uri;

            self.vimeoId = uri.replace(/\D/g, '');
            // getVimeoThumb(uri.replace(/\D/g, ''));
          },
          function (bytes_uploaded, bytes_total) {
            var percentage = ((bytes_uploaded / bytes_total) * 100).toFixed(2);
            console.log(bytes_uploaded, bytes_total, percentage + '%');
          },
          function (error) {
            console.log('Failed because: ' + error);
          }
        );
      } catch (ex) {
        console.log(ex);
      }
    },

    // async updateCandidateRecord(response) {
    //   var self = this;
    //   axios
    //     .put(
    //       process.env.VUE_APP_REST_HTTP
    //         ? `${process.env.VUE_APP_REST_HTTP}/candidates/${this.candidateId}`
    //         : `http://localhost:1337/candidates/${self.candidateId}`,
    //       {
    //         video: self.vimeoId,
    //         resume: response.data[0].id,
    //         job_posts: 1,
    //         //videoThumb: self.vimeoThumb,
    //       }
    //     )
    //     .then(function () {
    //       console.log('done');
    //       self.handleAppliedSuccess();
    //       //self.$store.dispatch('UPDATE_VIDEO', self.vimeoId);
    //     });
    // },

    async handleVideoSubmit() {
      console.log('video');
      let self = this;

      console.log(this.file);
      this.handleClose();

      // file upload
      let formData = new FormData();
      formData.append('files', this.file);
      console.log('>> formData >> ', formData);

      axios
        .post(
          process.env.VUE_APP_REST_HTTP
            ? `${process.env.VUE_APP_REST_HTTP}/upload`
            : 'http://localhost:1337/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then(function () {
          console.log('SUCCESS!!');
          // GET video ID that has just been updated
          axios
            .get(
              process.env.VUE_APP_REST_HTTP
                ? `${process.env.VUE_APP_REST_HTTP}/upload/files?_sort=created_at:DESC`
                : 'http://localhost:1337/upload/files?_sort=created_at:DESC'
            )

            .then(function (response) {
              console.log(response);
              console.log(self);
            });

          // update candidate with video ID
        })
        .catch(function () {
          console.log('FAILURE!!');
        });
    },

    handleSubmit() {
      console.log('submitted');
      const candidateId = this.candidateId;
      const file = this.file;
      const dialog = this.dialog;

      this.handleVideoSubmit(candidateId, file, dialog);

      //handle submit
    },

    handleFileChange() {
      this.file = this.$refs.file.files[0];
      console.log('>>>> 1st element in files array >>>> ', this.file);
    },
  },
  created() {},
};
</script>
<style lang="scss">
.apply span {
  color: white;
}
</style>
